import React from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';
import LazyLoad from 'react-lazy-load';
import { observer } from 'mobx-react';
import { getEmote } from '../../helpers/cdn';
import * as tableConstants from '../../pages/chatstats/constants';
import { take } from 'lodash';
import CountUp from 'react-countup';

import Text from '../Text';

const propTypes = {
    tableType: PropTypes.string.isRequired,
};

const TableRow = observer(({ classes, rowData, index, tableType, ...rest }) => {
    const { amount, id, key, prevAmount } = rowData;
    return (
        <div className={`${classes.tableRow} ${id ? 'rowHasEmote' : 'rowNoEmote'}`}>
            <Text classList={[ classes.index ]} type="text">{index + 1}</Text>
            <div className={classes.imageAreaContainer}>
                {
                    tableType.includes('Emote') && id &&
                    <div className={classes.imgWrap}>
                        <LazyLoad>
                            <img className={classes.img} src={getEmote(tableType, id)}/>
                        </LazyLoad>
                    </div>
                }
            </div>
            <Text classList={[ classes.key ]} type="text">{key}</Text>
            <Text type="text" classList={classes.count}
                  style={{ color: index < 3 ? tableConstants[ tableType ].colorPrimary : null }}>
                {amount.toLocaleString()}
            </Text>
        </div>
    );
});

const styles = theme => {
    return ( {
        tableRow: {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
            height: theme.channelItems.tables.rowHeight,
            marginRight: theme.spacing * 1.75, // 14px
            position: 'relative',
            '&:after': {
                content: '""',
                position: 'absolute',
                bottom: 0,
                right: 0,
                borderBottom: `1px ${theme.palette.border} solid`,
                width: 'calc(100% - 52px)'
            },

            '&.rowNoEmote p:first-child': {
                width: 44
            },

            '&.rowNoEmote p:nth-child(2)': {
                paddingLeft: theme.spacing
            }
        },
        index: {
            height: '100%',
            width: 32,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            textAlign: 'center',
            flexShrink: 0
        },
        key: {
            marginRight: 'auto',
            maxWidth: '100%',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            flexGrow: 1
        },
        imgWrap: {
            flexShrink: 0,
            marginRight: theme.spacing,
            width: '100%',
            height: '100%',
            padding: theme.spacing / 4,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: '50%',
            backgroundColor: 'white',
        },
        imageAreaContainer: {
            width: 33,
            height: 33
        },
        img: {
            width: 'auto',
            maxWidth: '80%',
        },
        count: {
            fontVariantNumeric: 'tabular-nums'
        }
    } )
};

TableRow.propTypes = propTypes;

export default injectSheet(styles)(TableRow);



// WEBPACK FOOTER //
// ./src/app/components/table/TableRow.js